"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _starRating = require("star-rating");

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _reviewAlt = _interopRequireDefault(require("../../src/styles/review-alt.scss"));

require("../../src/styles/external.scss");

var _propTypes = _interopRequireDefault(require("prop-types"));

var MOBILE_MAX_WIDTH = 767;
var LONG_TEXT_LENGTH = 256;

var ReviewAlt =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ReviewAlt, _React$Component);

  function ReviewAlt(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ReviewAlt);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReviewAlt).call(this, props));
    _this.state = {
      isReviewTextLong: false,
      isReviewReadMoreOpened: false
    };
    _this.onReadMoreClick = _this.onReadMoreClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ReviewAlt, [{
    key: "onReadMoreClick",
    value: function onReadMoreClick() {
      this.setState({
        isReviewReadMoreOpened: !this.state.isReviewReadMoreOpened
      });
    }
  }, {
    key: "updateReviewLengthStatus",
    value: function updateReviewLengthStatus() {
      var review = this.props.review;

      if (review) {
        if (review.length >= LONG_TEXT_LENGTH && this.state.isReviewTextLong === false) {
          this.setState({
            isReviewTextLong: true,
            isReviewReadMoreOpened: false
          });
        } else if (review.length < LONG_TEXT_LENGTH && this.state.isReviewTextLong === true) {
          this.setState({
            isReviewTextLong: false,
            isReviewReadMoreOpened: true
          });
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateReviewLengthStatus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateReviewLengthStatus();
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props,
          state = this.state;
      var date = props.date,
          review = props.review,
          rating = props.rating,
          ratings = props.ratings,
          likes = props.likes,
          specialist = props.specialist,
          comment = props.comment,
          className = props.className,
          disableLikeButton = props.disableLikeButton,
          loggedIn = props.loggedIn,
          buttonClicked = props.buttonClicked,
          onClick = props.onClick,
          onReportReview = props.onReportReview,
          isVerified = props.isVerified,
          source = props.source,
          keywords = props.keywords,
          starsClassName = props.starsClassName;
      var isReviewTextLong = state.isReviewTextLong,
          isReviewReadMoreOpened = state.isReviewReadMoreOpened;
      var reviewFormatted = review && isReviewTextLong && isReviewReadMoreOpened === false ? review.slice(0, LONG_TEXT_LENGTH) + '…' : review;
      var ratingsTransformed = ratings ? [{
        title: 'Overall',
        value: ratings.overallExperience
      }, ratings.explanation ? {
        title: 'Explanation',
        value: ratings.explanation
      } : null, ratings.bedsideManner ? {
        title: 'Bedside Manner',
        value: ratings.bedsideManner
      } : null].filter(Boolean) : [{
        title: 'Overall',
        rating: rating
      }];
      return _react.default.createElement("div", {
        className: "".concat(_reviewAlt.default.reviewContainer, " ").concat(className),
        style: props.style
      }, _react.default.createElement("div", {
        className: [_reviewAlt.default.block, _reviewAlt.default.flex].join(' ')
      }, ratingsTransformed.map(function (item) {
        return _react.default.createElement("div", {
          className: _reviewAlt.default.reviewRating
        }, _react.default.createElement("div", {
          className: _reviewAlt.default['reviewRating__title']
        }, item.title), _react.default.createElement(_starRating.StarRating, {
          averageRating: item.value,
          className: [_reviewAlt.default['reviewRating__stars'], starsClassName].filter(Boolean).join(' ')
        }));
      })), _react.default.createElement("div", {
        className: [_reviewAlt.default.block, _reviewAlt.default.review].join(' ')
      }, reviewFormatted, isReviewTextLong && _react.default.createElement("button", {
        className: _reviewAlt.default.readMoreButton,
        onClick: this.onReadMoreClick
      }, isReviewReadMoreOpened ? 'Read Less' : 'Read More')), keywords && keywords.length > 0 && _react.default.createElement("div", {
        className: _reviewAlt.default.block
      }, _react.default.createElement("span", {
        className: _reviewAlt.default.badgesTitle
      }, "Patient seen for:"), keywords.map(function (keyword) {
        return _react.default.createElement("span", {
          className: _reviewAlt.default.badge
        }, keyword);
      })), comment && _react.default.createElement("div", {
        className: [_reviewAlt.default.reviewComment, _reviewAlt.default.block].join(' ')
      }, _react.default.createElement("div", {
        className: _reviewAlt.default.commentContainer
      }, _react.default.createElement("h3", null, specialist), comment)), _react.default.createElement("div", {
        className: [_reviewAlt.default.block, _reviewAlt.default.flex].join(' ')
      }, _react.default.createElement("div", {
        className: _reviewAlt.default.flex
      }, isVerified && _react.default.createElement("div", {
        className: _reviewAlt.default.reviewFooterItem
      }, "Verified Patient"), date && _react.default.createElement("div", {
        className: _reviewAlt.default.reviewFooterItem
      }, date), source && _react.default.createElement("div", {
        className: _reviewAlt.default.reviewFooterItem
      }, source)), _react.default.createElement("div", {
        className: _reviewAlt.default.flex
      }, !disableLikeButton && _react.default.createElement("div", {
        className: [_reviewAlt.default.likeButtonContainer, loggedIn ? _reviewAlt.default['likeButtonContainer_loggedIn'] : _reviewAlt.default['likeButtonContainer_loggedOut']].join(' '),
        "data-tip": "You must be logged in to like a comment",
        "data-for": "react-tooltip"
      }, "Helpful?", _react.default.createElement("button", {
        disabled: loggedIn ? '' : 'disabled',
        onClick: onClick,
        className: [_reviewAlt.default.likeButton, buttonClicked && loggedIn ? _reviewAlt.default['likeButton_clicked'] : null].filter(Boolean).join(' ')
      }, _react.default.createElement("i", {
        className: 'ion-thumbsup'
      })), likes, loggedIn ? null : _react.default.createElement(_reactTooltip.default, {
        id: "react-tooltip",
        place: typeof window !== 'undefined' && window.innerWidth > MOBILE_MAX_WIDTH ? 'top' : 'right'
      })), onReportReview && _react.default.createElement("div", {
        className: _reviewAlt.default.reportButtonContainer
      }, _react.default.createElement("button", {
        className: _reviewAlt.default.reportButton,
        onClick: onReportReview
      }, _react.default.createElement("i", {
        className: "ion-ios-flag"
      }))))));
    }
  }]);
  return ReviewAlt;
}(_react.default.Component);

(0, _defineProperty2.default)(ReviewAlt, "propTypes", {
  date: _propTypes.default.string,
  review: _propTypes.default.string,
  likes: _propTypes.default.number,
  rating: _propTypes.default.number,
  ratings: _propTypes.default.shape({
    overallExperience: _propTypes.default.number.isRequired,
    explanation: _propTypes.default.number,
    bedsideManner: _propTypes.default.number,
    cleanliness: _propTypes.default.number,
    friendliness: _propTypes.default.number
  }).isRequired,
  specialist: _propTypes.default.string,
  comment: _propTypes.default.string,
  className: _propTypes.default.string,
  disableLikeButton: _propTypes.default.bool,
  loggedIn: _propTypes.default.bool,
  buttonClicked: _propTypes.default.bool,
  onClick: _propTypes.default.string,
  onReportReview: _propTypes.default.string,
  isRatingTextValueShown: _propTypes.default.bool,
  isVerified: _propTypes.default.bool.isRequired,
  source: _propTypes.default.string,
  keywords: _propTypes.default.arrayOf(_propTypes.default.string.isRequired),
  style: _propTypes.default.object,
  starsClassName: _propTypes.default.string
});
ReviewAlt.displayName = 'ReviewAlt';
ReviewAlt.defaultProps = {
  disableLikeButton: false,
  isRatingTextValueShown: false
};

var _default = (0, _reactIntl.injectIntl)(ReviewAlt);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/review/lib/components/review-alt.js
// module id = 2205
// module chunks = 0